import BaseService from './BaseService';
import { camelizeKeys } from 'humps';
import normalize from 'jsonapi-normalizer';
import dates from '@/utils/dates';

const objectType = 'no-sprays';

class NoSprayService extends BaseService {
  static getList(page) {
    return super
      .get(`no_sprays?page[number]=${page}&page[size]=${this.pageSize()}`)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static search(search, page) {
    return super
      .get(
        `no_sprays/search?search[field]=${search.field}&search[term]=${search.term}&page[number]=${page}`
      )
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }

  static getDetails(id) {
    return super
      .get(`no_sprays/${id}`)
      .then((response) => {
        let object = normalize(response.data);
        let data = object.entities['no-sprays'][object.result['no-sprays'][0]];
        data = camelizeKeys(data);
        data = dates.datepickerFormat(data, ['deactivatedDate']);

        return Promise.resolve(data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static create(data) {
    if (data.deactivatedDate) {
      data = dates.apiFormat(data, ['deactivatedDate']);
    }

    return super
      .post(objectType, `no_sprays`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static update(data) {
    if (data.deactivatedDate) {
      data = dates.apiFormat(data, ['deactivatedDate']);
    }

    return super
      .patch(objectType, `no_sprays/${data.id}`, data)
      .then((response) => {
        return Promise.resolve(camelizeKeys(response.data.data));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.errors[0].detail);
      });
  }

  static delete(id) {
    return super
      .delete(`no_sprays/${id}`)
      .then((response) => {
        return Promise.resolve({ id });
      })
      .catch((error) => {
        return Promise.reject(error.response.data);
      });
  }
}

export default NoSprayService;
